import React, { lazy, Suspense } from 'react';

import clientOnly from '../../../../common/hoc/clientOnly';

const App = lazy(() =>
  import(/* webpackChunkName: "EventsList" */ './EventsList')
);

const EventsList = props => (
  <Suspense fallback={null}>
    <App {...props} />
  </Suspense>
);

export default clientOnly(EventsList);
